import _ from 'lodash';
import { CARD_VALUES, CARDS } from '../constants';

export function getCurrentPot(communityCards: string[]) {
    const values = communityCards.map(card => CARD_VALUES[card]);
    return _.sum(values);
}

export function getExpectedPot(holeCards: string[], communityCards: string[] = [], opponentsCards: string[][] = []) {
    const currentPot = getCurrentPot(communityCards);

    const visibleCards = _.flattenDeep([holeCards, communityCards, opponentsCards]);
    const remainingCards = _.difference(CARDS, visibleCards);
    const remainingValues = remainingCards.map(card => CARD_VALUES[card]);
    const remainingMean = _.mean(remainingValues);

    const remainingCommunityCards = 5 - communityCards.length;
    const expectedValue = remainingMean * remainingCommunityCards;

    return _.round(currentPot + expectedValue, 1);
}

/**
 * Expected value of a hand = the expected final pot weighted by the probability
 * of winning it. Extracted from Game.tsx (`expectedPot * winProbability`) so the
 * financial-math computation is unit-testable at PR time rather than only being
 * exercised through the rendered game context.
 */
export function getExpectedValue(expectedPot: number, winProbability: number) {
    return expectedPot * winProbability;
}
